import { domain } from "../Services/Routes/API";

export const getPagination = (count) => {
  let remainder = count % 10;
  if (remainder === 0) {
    return count / 10;
  } else {
    let page = count / 10;
    return parseInt(page + 1);
  }
};

export const getAllIndexes = (arr, val) => {
  var indexes = [],
    i = -1;
  while ((i = arr.indexOf(val, i + 1)) != -1) {
    indexes.push(i);
  }
  return indexes;
};

export const getNthIndexOfSubstringInString = (string, subString, index) => {
  return string.split(subString, index).join(subString).length;
};

export const replaceAt = (string, index, replacement) => {
  return (
    string.slice(0, index) +
    replacement +
    string.slice(index + replacement.length)
  );
};

export const convertToFormData = (obj, namespace = null, form = null) => {
  //namespace && form used for recursive call
  const newFormData = form || new FormData();
  let formKey;

  for (const property in obj) {
    if (typeof obj[property] === "boolean") {
      obj[property] = obj[property].toString();
    }

    if (obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + "[" + property + "]";
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        newFormData.append(formKey, obj[property].toISOString());
      } else if (
        typeof obj[property] === "object" &&
        !(obj[property] instanceof File)
      ) {
        convertToFormData(obj[property], formKey, newFormData);
      } else {
        // if it's a string or a File object
        newFormData.append(formKey, obj[property]);
      }
    }
  }

  return newFormData;
};

export const titlizeString = (str) => {
  if (typeof str === "string")
    return str.charAt(0).toUpperCase() + str.slice(1);
  else return "";
};

export const refreshLayout = () => {
  const layoutRefresher = window.document.getElementById("layout-refresher");
  layoutRefresher.click();
};

export const ROLE_METHODS = {
  roleBasedAPIRoute: (role) => {
    return `${domain}/api/admin/${pluralizeRole(apiBasedRole(role))}`;
  },
  appBasedRole: (role) => appBasedRole(role),
  apiBasedRole: (role) => apiBasedRole(role),
  pluralizeRole: (role) => pluralizeRole(role),
  getAppBased1stChildRole: (role) => getAppBased1stChildRole(role),
};

const pluralizeRole = (role) => {
  switch (role) {
    case "super_admin":
      return "super_admins";
    case "admin":
      return "admins";
    case "ministry":
      return "ministries";
    case "province":
      return "provinces";
    case "provincial":
      return "provincial";
    case "state":
      return "states";
    case "district":
      return "districts";
    case "hospital":
      return "hospitals";
    case "clinic":
      return "clinics";
    case "pou":
      return "clinics";
    default:
      return "";
  }
};

const getAppBased1stChildRole = (role) => {
  switch (role) {
    case "admin":
      return "ministry";
    case "ministry":
      return "provincial";
    case "provincial":
      return "district";
    case "district":
      return "pou";
    default:
      return "";
  }
};

const apiBasedRole = (role) => {
  switch (role) {
    case "admin":
      return "super_admin";
    case "provincial":
      return "state";
    case "pou":
      return "hospital";
    case "clinic":
      return "hospital";
    default:
      return role;
  }
};

const appBasedRole = (role) => {
  switch (role) {
    case "super_admin":
      return "admin";
    case "state":
      return "provincial";
    case "hospital":
      return "pou";
    default:
      return role;
  }
};
